const VERSION = '2.0.17a'
export default VERSION
